export const differentTimeMinutes = (dateTimeStamp) => {
    // var x = new Date(dateTimeStamp* 1000);
    // console.log('x', x);
    let diffInMilliSeconds = Math.abs(new Date(dateTimeStamp * 1000) - new Date() );
    // console.log('diffInMilliSeconds', diffInMilliSeconds);

    // // calculate days
    // const days = Math.floor(diffInMilliSeconds / 86400);
    // diffInMilliSeconds -= days * 86400;
    // console.log('calculated days', days);

    // // calculate hours
    // const hours = Math.floor(diffInMilliSeconds / 3600) % 24;
    // diffInMilliSeconds -= hours * 3600;
    // console.log('calculated hours', hours);

    // calculate minutes
    const minutes = Math.floor((diffInMilliSeconds /1000) / 60);
    // diffInMilliSeconds -= minutes * 60;
    // console.log('minutes', minutes);

    return minutes
}
